import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { signupSearchParams } from 'router/search/signup';
import { headSignupSubRoute } from 'router/utils';

export const Route = createFileRoute('/start/others')({
  validateSearch: zodValidator(signupSearchParams),
  head: headSignupSubRoute,
});
